const EVENTS_PREFIX = 'EGD'

const WEBUI_EVENTS = {
  // dashboard
  DASHBOARD_VIEW: `${EVENTS_PREFIX} Dashboard Pageview`,

  // login
  LOGIN_PAGE_VIEW: `${EVENTS_PREFIX} Login Pageview`,
  AUTOLOGIN_ACTION_PAGE_VIEW: `${EVENTS_PREFIX} AutoLogin Action Pageview`,
  AZURE_SSO_PAGE_VIEW: `${EVENTS_PREFIX} Azure SSO Pageview`,
  LOGIN_SUCCESS: `${EVENTS_PREFIX} Login Success`,

  // message log
  MESSAGE_LOG_PAGE_VIEW: `${EVENTS_PREFIX} Message Log Pageview`,
  MESSAGE_DETAIL_PAGE_VIEW: `${EVENTS_PREFIX} Message Detail Pageview`,
  REPORT_INCORRECTLY_DELIVERED: `${EVENTS_PREFIX} Message Log Report as incorrectly delivered`,
  REPORT_INCORRECTLY_BLOCKED: `${EVENTS_PREFIX} Message Log Report as incorrectly blocked`,
  PROVIDE_ADDITIONAL_DETAILS: `${EVENTS_PREFIX} Message Log Provide Additional Details button`,

  // reset password
  RESET_PASSWORD_PAGE_VIEW: `${EVENTS_PREFIX} Reset Password Action Pageview`,

  // verify link account
  VERIFY_LINK_ACCOUNT_PAGE_VIEW: `${EVENTS_PREFIX} Verify Link Account Action Pageview`,

  // support
  SUPPORT_PAGE_VIEW: `${EVENTS_PREFIX} Support Pageview`,

  // settings
  SETTINGS_BULK_EDIT_PAGE_VIEW: `${EVENTS_PREFIX} Settings Bulk Edit Pageview`,
  SETTINGS_CHANGE_PASSWORD_PAGE_VIEW: `${EVENTS_PREFIX} Settings Change Password Pageview`,
  SETTINGS_LINKED_ACCOUNTS_PAGE_VIEW: `${EVENTS_PREFIX} Settings Linked Accounts Pageview`,
  SETTINGS_QUARANTINE_NOTIFICATION_PAGE_VIEW: `${EVENTS_PREFIX} Settings Quarantine Notificaion Pageview`,
  SETTINGS_SENDER_POLICIES_PAGE_VIEW: `${EVENTS_PREFIX} Settings Sender Policies Pageview`,

  // License Compliance Page
  LC_PAGEVIEW: `${EVENTS_PREFIX} License Compliance Pageview`,

  // Domains page
  DOMAINS_PAGE_VIEW: `${EVENTS_PREFIX} Domains Pageview`,

  // Domain > Edit > Azure AD authorized event
  AZURE_AD_CONFIG_ATTEMPT_EVENT: `${EVENTS_PREFIX} Azure AD Configuration Attempt`,
  AZURE_AD_CONFIG_SUCCESS_EVENT: `${EVENTS_PREFIX} Azure AD Configuration Success`,
  AZURE_AD_CONFIG_FAILURE_EVENT: `${EVENTS_PREFIX} Azure AD Configuration Failed`,

  // Reports Page
  REPORT_LIST_PAGE_VIEW: `${EVENTS_PREFIX} Report list Pageview`,
  SCHEDULE_REPORTS_PAGE_VIEW: `${EVENTS_PREFIX} Schedule Reports Pageview`,
  REPORT_CREATION: `${EVENTS_PREFIX} Report Created`,
  SCHEDULE_REPORT: `${EVENTS_PREFIX} Schedule Report`,
  DOWNLOAD_REPORT: `${EVENTS_PREFIX} Report Downloaded`,

  // setup event
  VERIFIED_FIRST_DOMAIN: `${EVENTS_PREFIX} Verified First Domain`,
  MAIL_FLOW_STARTED: `${EVENTS_PREFIX} Customer account started mail flow`,

  // Opt in event
  OPTED_IN_REACT: 'Bcc user optin enabled and switched to react',

  // Email banners events
  EMAIL_BANNERS_ENABLED: `${EVENTS_PREFIX} Email warning banners enabled`,
  EMAIL_BANNERS_TURNED_OFF: `${EVENTS_PREFIX} Customer account has turned the feature ON or TESTING MODE and later turned feature OFF`,

  // EP access event
  HAS_EP_ACCESS: `${EVENTS_PREFIX} EP Access to EGD only users`
} as const

export default WEBUI_EVENTS
